import { createFileRoute } from "@tanstack/react-router";
import NotFound from "@/pages/NotFound";

// Prerendered and copied to 404.html so the static host serves the branded page for unknown URLs.
export const Route = createFileRoute("/not-found")({
  head: () => ({
    meta: [
      { title: "Page Not Found | JTB Floors" },
      { name: "description", content: "This page doesn't exist. Find flooring services, our work, or contact JTB Floors." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: NotFound,
});
